module.exports = __webpack_public_path__ + "static/img/13.96b763a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/13.png
// module id = g+Xx
// module chunks = 0